import React, { memo} from 'react';
import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";
import "./device.selection.component.scss";

interface Option {
    value: string;
    label: string;
}

interface DeviceSelectionProps {
    value: string;
    options: Option[];
    changeHandler: (value: string) => void;
}

const DeviceSelectionComponent: React.FC<DeviceSelectionProps> = ({
    value,
    options,
    changeHandler
}) => {
    return (
        <div className="device-selection">
            <div className="device-selection-header">
                <b>I could see you are using multiple systems. If you would like to perform following action on different system please choose from the list below</b>
            </div>
            <div className='device-selection-body'>
                <span className="note">Choose the system for Nexthink action</span>
                <div className="device-options">
                    <EonUiDropdown
                        onValueChanged={(event) => {changeHandler(event.target.value)}}
                        value={value}
                        name="dropdown"
                        size="small"
                    >
                        {options.map((val, index) => (
                            <EonUiDropdownOption
                                key={`${index.toString()}`}
                                value={val.value}
                                label={val.label}
                            />
                        ))}
                    </EonUiDropdown>
                </div>
            </div>
        </div>
    );
};

export default memo(DeviceSelectionComponent);